import { HpSvgIconTypes, SvgIcon } from '@avantia/style-guide';
import { Col, Row } from 'react-bootstrap';

import './infoBox.scss';

interface InfoBoxProps {
  mainText: string;
  subText?: string | null;
  actionButton?: JSX.Element;
  handleClick?: () => void;
  testId?: string;
  icon?: HpSvgIconTypes;
  className?: string;
}

export const InfoBox = ({
  mainText,
  subText,
  actionButton,
  handleClick,
  testId,
  icon,
  className
}: InfoBoxProps): JSX.Element => {
  const renderContent = (): JSX.Element => {
    const content = (
      <Row className={`info-box ${className}`}>
        <Col xs={actionButton ? 10 : 12} sm={actionButton ? 11 : 12}>
          <div className="info-box-main">
            {icon && <SvgIcon type={icon} size="semi-tiny" className="info-box-icon" />}
            <div className="info-box-text">
              <p>{mainText}</p>
            </div>
          </div>
          {subText && (
            <div className="info-box-sub">
              <p>{subText}</p>
            </div>
          )}
        </Col>
        {actionButton && (
          <Col xs={2} sm={1} className="info-box-action">
            {actionButton}
          </Col>
        )}
      </Row>
    );

    if (handleClick) {
      return (
        <a onClick={handleClick} data-testid={testId}>
          {content}
        </a>
      );
    }

    return content;
  };

  return renderContent();
};
